
/**
 * @name appMessageBase
 * @description
 * This is config file, it include only global application related messages
 * Define Settings the object way(based on requirement):
 * @example {paramsName}:{value}
 * @constant appMessageBase
 */
export const appMessageBase = {
  sessionUpdated: 'Session has been updated successfully.',
  sessionCreated: 'Session has been created successfully.',
  goLive: "You are in the green room. The session is currently Off Air.",
  inviteLink: 'Invite link has been copied successfully.',
  linkCopied: 'Link has been copied to clipboard.',
  passwordChanged: 'Password has been changed successfully.',
  sessionRecorded: 'This session is being recorded.',
  paymentSuccess: 'Your payment has been successful.',
  updateCard: 'Card changed successfully.',
  forgotPass: "We sent password reset instructions to your email address",
  resetPass: 'Your password was changed successfully.',
  emailConfrim: 'A confirmation email has been sent to your registration email address, please confirm the email.',
  emailConfrimed: 'Congratulations! your Email ID has been verified. Login to begin with Boomcaster.',
  closeTabs: 'Expert Tip: Close all unused applications and browser tabs to record this session at the highest quality possible.',
  safariMac: 'Safari is not supported. Please use Chrome or Edge to join session!',
  firefoxMsg: 'Firefox is not supported. Please use Chrome or Edge to join session!',
  braveMsg: 'Brave is not supported. Please use Chrome or Edge to join session!',
  crios: 'Chrome does not currently support this recording technology in iOS.',
  edgeMac: 'Edge is not supported on MacOS',
  iosSafari: 'Safari supports this technology only through experimental features.',
  crandroid: 'Please use the latest version of Chrome (81+) for Android',
  closeUplaod: 'We are still processing your recording, on refresh/closing, the data will be lost. Please wait.',
  recUploadSuccess: 'Recording has been uploaded successfully.',
  recUploadBannerSuccess: 'Recording was saved to the cloud. You can hang up the call any time',
  hostRecSavedBanner: 'Recording has been saved to your dashboard. You can hang up the call any time!',
  guestRecSavedBanner: 'Recording has been saved and sent to the host. You can hang up the call any time!',
  delSessonTitle: 'Delete this session?',
  delSessionDes: 'This session and all its recordings will be deleted immediately. You can’t undo this action.',
  delRecTitle: 'Delete this recording?',
  delRecDes: 'This session recording will be deleted immediately. You can’t undo this action.',
  recConfSuccess: 'Recording configuration is saved.',
  participantLimit: 'Oops! This session is at capacity.',
  recBannerMsg: 'This session is being recorded.',
  waitHost: '',
  stopRec: 'Stop recording this session?',
  endSession: 'Are you sure you want to End Broadcast?',
  recSaved: 'We are saving your local recording. If you end the call, leave this browser tab open.',
  recoveryLink: 'Recovery link is copied sucessfully, share this link with participant',
  expireMsg: 'Your free trial has ended.',
  referralCode: 'referral code is copied.',
  outdatedTitle: 'Your browser is outdated',
  outdatedChromeMsg: 'You are running an older version of Chrome. Please <a href="https://www.google.com/chrome/update/" target="_blank">upgrade</a> to the latest version to join session!',
  outdatedEdge: 'You are running an older version of Edge. Please upgrade to the latest version to join session!',
  mobileSupportMsg: 'Sessions on mobile devices will be supported soon. Until then, join session from a desktop or laptop.',
  commingSoon: 'Coming Soon!',
  browserNotSupport: 'Browser not supported',
  leaveTheCall: 'Are you sure you want to leave the call?',
  subscriptionExpireTitle: 'Your trial subscription has expired!',
  subscriptionExpireDescription: 'To continue Boomcasting, please upgrade your plan in “Account Settings”.',
  subscriptionUpgradeTitle: 'Upgrade subscription',
  subscriptionUpgradeDescription: 'Your free subscription quota is exhausted, upgrade the plan to continue.',
  lowMemoryTitle: 'Low Disk Space',
  lowMemoryDescrition: `Disk space is too low on this device to record in studio quality. Try connecting from a different device.If you continue, only web recording is guaranteed.`,
  storageApprochingFull: 'You are approaching storage limit allocated for the plan (100GB). Buy more storage  or delete old sessions to free up space.',
  storageFull: 'You have exceeded your allocated storage (100GB).',
  privateWindowTitle: 'Private/Incognito Browsing',
  privateWindowDescription: 'Private/Incognito mode is not supported. Rejoin session in regular browsing mode.'
};

/**
 * displaying error message to user
 */
export const errorMessage = {
  httpError: 'An error occurred while fetching the response. Please try again.',
  Navigator: 'Navigator does not exist.',
  invalidSession: "Invalid session.",
  invalidUserEmailPass: 'Invalid email or password.',
  inactiveUser: 'An email has been sent with instructions to verify your account.',
  forgotPass: "No result found. Check your email address.",
  recordingDel: "Recording not deleted.",
  sessionDel: 'Session not deleted.',
  startRec: "There is an issue while starting the live recording.",
  fbLive: 'There is some issue while going live on Facebook.',
  fbConnect: 'Connect Facebook account in account setting.',
  gbConnect: 'Connect Youtube account in account setting.',
  ytLive: 'There is some issue while going live on YouTube.',
  emailConfrimed: 'Link is invaild or expired.',
  fileType: 'Image supported format is jpg, jpeg and png.',
  imgSize: 'Image recommended size (93x39)',
  ytThumbnailResolution: 'Maximum thumbnail resolution is 1280x720 px',
  ytThumbnailFileSize: 'Maximum file size is 2MB',
  joinSession: 'There is some error while joining the session , please retry.',
  common: 'There is some error, please retry again.'
};

/**
 * [DONT CHNAGE UNLESS YOU CHECK IT WITH API RESPONSE]
 * error code message used to store the actual message of exception 
 * ***do not change these message without inspecting
 * used to match the exception message with this const message
 */
export const errorCodeMsg = {
  wrtcVSrc: 'Could not start video source',
  wrtcASrc: 'Could not start audio source',
  recordingInProc: "Recording already in progress",
  openSession: 'A session has already been opened'
}
